import React from 'react';
import google_btn from './assets/images/google-btn.png';
import appstore_btn from './assets/images/appstore-btn.png';

class Banner extends React.Component {
    constructor(props) {
        super(props);
    }

    showAppButtons = () => {
        if (this.props.bannerDetails && this.props.bannerDetails.show_app_buttons) {
            return (
                <>
                    <p>
                        <strong>Download our app:</strong>
                    </p>
                    <div className="wrap-social-btn">
                        {this.showIosButton()}
                        {this.showAndroidButton()}
                    </div>
                </>
            )
        }
    }

    showAndroidButton() {
        if (this.props.bannerDetails && this.props.bannerDetails.android_url_enabled) {
            return (
                <a className="google-play-btn" target="_blank"
                   href={this.props.bannerDetails && this.props.bannerDetails.android_url}>
                    <img src={google_btn} alt="Get It On Google Play"
                         title="Get It On Google Play"/>
                </a>
            )
        }
    }

    showIosButton() {
        if (this.props.bannerDetails && this.props.bannerDetails.ios_url_enabled) {
            return (
                <a className="app-store-btn" target="_blank"
                   href={this.props.bannerDetails && this.props.bannerDetails.ios_url}>
                    <img src={appstore_btn} alt="Available On the App Store"
                         title="Available On the App Store"/>
                </a>
            )
        }
    }

    backToHome = (e) => {
        e.preventDefault();
        window.scrollTo({top: 0, behavior: 'smooth'});
        return true;
    }

    showLogo = () => {
        if (this.props.headerInfo && this.props.headerInfo.web_logo_type === 'horizontal_logo') {
            return (
                <a className="logo" href='#' onClick={this.backToHome}>
                    <img className="logo__image" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                </a>
            )
        }
        if (this.props.headerInfo && this.props.headerInfo.web_logo_type === 'square_logo_and_name') {
            return (
                <a className="logo square_name" href='#' onClick={this.backToHome}>
                    <img className="logo__image logo__image--sqaure_name" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                    <span className="logo__name">{this.props.headerInfo && this.props.headerInfo.web_title}</span>
                </a>
            )
        } else {
            return (
                <a className="logo" href='#' onClick={this.backToHome}>
                    <img className="logo__image" alt={document.title}
                         src={this.props.headerInfo && this.props.headerInfo.web_logo}/>
                </a>
            )
        }
    }

    bannerContent = () => {
        if (this.props.headerInfo && this.props.headerInfo.web_logo_type === 'square_logo') {
            return (
                <div className='bg-white'>
                    <div className='left'>
                        <h1>{this.props.bannerDetails && this.props.bannerDetails.title}</h1>
                        <div className="pb-15">
                            {this.props.bannerDetails && this.props.bannerDetails.description.split('\n').map(i => {
                                return <p>{i}</p>
                            })}
                        </div>
                    </div>
                    <div className='right'>
                        {this.showLogo()}
                        {this.showAppButtons()}
                    </div>


                </div>
            )
        } else {
            return (
                <div className='bg-white horizontal-logo'>
                    {this.showLogo()}

                    <h1>{this.props.bannerDetails && this.props.bannerDetails.title}</h1>
                    <div className="pb-15">
                        {this.props.bannerDetails && this.props.bannerDetails.description.split('\n').map(i => {
                            return <p>{i}</p>
                        })}
                    </div>


                    {this.showAppButtons()}
                </div>

            )
        }
    }

    render() {
        return (
            <section className="top-banner banner__section top__section top__section__charcoal">
                <div className="content">
                    <div className="two-column">
                        <div className="left-column  banner-column">
                            {this.bannerContent()}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Banner;